//Files and images upload
import axios from 'axios'

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    fileUpload({commit}, files) {

        let responseArray = []
        let promises = []

        files.forEach((item, index) => {        
            let formData = new FormData()
            formData.append('file', item)
            promises.push(   
                axios({
                    method: 'POST',
                    url: 'imageupload',
                    data: formData,
                    headers: {'Content-Type': 'multipart/form-data'}
                })
                .then(response => {
                    return response
                })
                .catch(err => {
                    console.error('Ошибка отправки файла: ', err)
                })
            )
        })

        // return Promise.all(promises).then(response => {return response})
        
        return axios.all(promises)
            .then(axios.spread((...responses) => {

                return responses
            }))
            .catch(err => {
                console.error('Ошибка очереди загрузки файлов: ', err)
            })
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}